import React from 'react';
import { WebsiteName } from '../../App';
import HeroPost from '../Hero/HeroPost';

const BlogPostDetail = props => {
    const { thumb, title, fullDesc } = props.blogData;

    document.title = title + " | " + WebsiteName;

    return (
        <>
            <HeroPost blogData={props.blogData}></HeroPost>
            <main>
                <section className="single" id="single">
                    <div className="container fullwidth">
                        <div className="ppContent">
                            {thumb && <img src={thumb} alt={title} />}
                            {fullDesc}
                        </div> {/* Content */}
                    </div> {/* Container */}
                </section> {/* Single */}
            </main>
        </>
    );
};

export default BlogPostDetail;